"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const time_expire_png_1 = __importDefault(require("images/stock/time-expire.png"));
const Button_1 = __importDefault(require("../../../../../components/Button"));
const CheckPhoneExpire = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const handleButton = () => {
        history.push('/credit-portal/prove/');
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsx)("img", { src: time_expire_png_1.default, className: "w-auto", width: "64px", height: "64px", alt: "Time Expired" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("h2", { className: "font-family-bold", children: "Expired Verification Link" }), (0, jsx_runtime_1.jsx)("p", { className: "p-20 mar-y-20", children: "Your phone verification link has expired. Click below to start again." }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(Button_1.default, { type: "button", "data-testid": "start-over-expire-btn", onClick: handleButton, className: `button-primary button-warn-outline`, children: "Pre-Qualify" })] }));
};
exports.default = CheckPhoneExpire;
